<template>
    <div class="home-page">
        <div class="top-content">
            <carousel></carousel>
            <game-news></game-news>
        </div>
        <hot-games></hot-games>
        <partner></partner>

    </div>
</template>

<script>
    import Carousel from './home/Carousel.vue'
    import GameNews from './home/GameNews.vue'
    import HotGames from './home/HotGames.vue'
    import Partner from './home/Partner.vue'

    export default {
        components: {
            Carousel,
            GameNews,
            HotGames,
            Partner
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../assets/scss/lib.scss";

    .home-page {
        padding-bottom: 30px;
    }

    .top-content {
        width: 100%;
        height: 757px + 210px;
        margin: 0 auto;
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// Home.vue?aa81217c